import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'

import { ReactComponent as LogoSVG } from '~media/global/wordmark.svg'

export default function Logo({ variation, ...rest }) {
  const theme = useTheme()

  return (
    <LogoSVG
      css={[
        variation === 'black' && { color: theme.color.dark.base },
        variation === 'white' && { color: theme.color.light.base },
        variation === 'green' && { color: theme.color.primary.base },
      ]}
      {...rest}
    />
  )
}

Logo.propTypes = {
  variation: PropTypes.oneOf(['black', 'white', 'green']),
}
